module.exports = __webpack_public_path__ + "static/img/zhutu插秧机.8367ab4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/model/zhutu插秧机.png
// module id = FU37
// module chunks = 0